import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { FlexBox, Link, Skeleton, styled, Typography } from 'ml-rubiks-styleguide';
import { injectTSDI } from 'ml-webclient-common/src/tsdi';
import { I18nStore } from '../../core/i18n';
import { FastFinanceLinkStore } from '../../store';
const FooterRoot = styled(FlexBox)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper
}));
function getLegalUrl(legalItem) {
    if (legalItem?.legalLinkType === 'EXTERNAL_URL' && legalItem.content) {
        return legalItem.content;
    }
    return undefined;
}
export const Footer = observer(function Footer() {
    const store = injectTSDI(FastFinanceLinkStore);
    const i18n = injectTSDI(I18nStore);
    const { studioInfo, legal } = store;
    const legalLinks = [
        {
            label: i18n.__('ffl.studio.footer.title.privacy'),
            href: getLegalUrl(legal?.privacy)
        },
        {
            label: i18n.__('ffl.studio.footer.title.revocation.terms'),
            href: getLegalUrl(legal?.revocation)
        },
        {
            label: i18n.__('ffl.studio.footer.title.imprint'),
            href: getLegalUrl(legal?.imprint)
        },
        {
            label: i18n.__('ffl.studio.footer.title.general.terms'),
            href: getLegalUrl(legal?.termsAndConditions)
        }
    ].filter((link) => Boolean(link.href));
    return (_jsx(FooterRoot, { component: "footer", hAlign: "space-between", vAlign: "center", gap: 2, sx: {
            p: 3,
            flexWrap: 'wrap'
        }, children: !i18n.isReady ? (_jsxs(_Fragment, { children: [_jsxs(FlexBox, { vAlign: "center", gap: 2, children: [_jsx(Skeleton, { variant: "rectangular", width: 32, height: 32 }), _jsx(Skeleton, { variant: "text", width: 120, height: 16 })] }), _jsxs(FlexBox, { gap: 2, hAlign: "flex-end", sx: { flexWrap: 'wrap' }, children: [_jsx(Skeleton, { variant: "text", width: 80, height: 16 }), _jsx(Skeleton, { variant: "text", width: 80, height: 16 }), _jsx(Skeleton, { variant: "text", width: 80, height: 16 })] })] })) : (_jsxs(_Fragment, { children: [_jsx(FlexBox, { vAlign: "center", gap: 2, children: _jsx(Typography, { variant: "body2", color: "text.secondary", children: studioInfo?.studioName }) }), _jsx(FlexBox, { gap: 2, hAlign: "flex-end", sx: { flexWrap: 'wrap' }, children: legalLinks.map((link) => (_jsx(Link, { href: link.href, target: "_blank", rel: "noopener noreferrer", underline: "hover", variant: "body2", color: "text.secondary", children: link.label }, link.label))) })] })) }));
});
